import { defineMessages } from 'react-intl';

export default defineMessages({
    policyChangeStartedTWIA: {
        id: 'gateway.views.TWIA.endorsement-detail.This policy change has been started.',
        defaultMessage: 'This policy change has been started.',
    },
    policyChangeStartedTFPA: {
        id: 'gateway.views.TFAP.endorsement-detail.This policy change has been successfully started.',
        defaultMessage: 'This policy change has been successfully started.',
    },
    withdrawPolicyChange: {
        id: 'gateway.views.TWIA.endorsement-detail.Withdraw Policy Change',
        defaultMessage: 'Withdraw Policy Change',
    },
    continuePolicyChange: {
        id: 'gateway.views.TWIA.endorsement-detail.Continue Policy Change',
        defaultMessage: 'Continue Policy Change',
    },
    policyChangePremiusCalculated: {
        id: 'gateway.views.TWIA.endorsement-detail.The premium for this policy change has been calculated',
        defaultMessage:
            'The premium for this policy change has been calculated.',
    },
    policyChangePremiusCalculated_TFPA: {
        id: 'gateway.views.TFPA.endorsement-detail.The premium for this policy change has been calculated',
        defaultMessage:
            'Premium for this policy change has been calculated.',
    },
    mayWithDrawPolicyChange: {
        id: 'gateway.views.TWIA.endorsement-detail.You may withdraw the policy change',
        defaultMessage: 'You may withdraw the policy change',
    },
    policyWithdrawn: {
        id: 'gateway.views.TWIA.endorsement-detail.This policy change has been withdrawn',
        defaultMessage: 'This policy change has been withdrawn',
    },
    expiredMessage: {
        id: 'gateway.views.endorsement-detail.This policy change has expired.',
        defaultMessage: 'This policy change has expired.',
    },
    policyChangeBound: {
        id: 'gateway.views.TWIA.endorsement-detail.This policy change has been bound',
        defaultMessage: 'This policy change has been bound.',
    },
    ChangeBound: {
        id: 'gateway.views.TWIA.endorsement-detail.Change has been bound.',
        defaultMessage: 'Change has been bound.',
    },
    mayWithdrawOrContinuePolicyChangeWizard: {
        id: 'gateway.views.TWIA.endorsement-detail.You may either withdraw or continue to the policy change wizard',
        defaultMessage:
            'You may either withdraw or continue to the policy change wizard',
    },
    mayWithdrawOrContinueTWIA: {
        id: 'gateway.views.TWIA.endorsement-detail.You may either withdraw or continue this change.',
        defaultMessage:
            'You may either withdraw or continue this change.'
    },
    mayWithdrawOrContinueTFPA: {
        id: 'gateway.views.TFPA.endorsement-detail.You may either withdraw this change or continue to the policy change wizard.',
        defaultMessage:
            'You may either withdraw or continue to the policy change wizard.',
    },
    mayWithdrawPolicyChange: {
        id: 'gateway.views.TWIA.endorsement-detail.You withdraw the policy change',
        defaultMessage: 'You withdraw the policy change',
    },
    lastDays: {
        id: 'gateway.views.TWIA.endorsement-detail.last30Days',
        defaultMessage: 'Issued in Last 30 Days',
    },
    openBound: {
        id: 'gateway.views.TWIA.endorsement-detail.Open - Bound',
        defaultMessage: 'Open - Bound',
    },
    openNotBound: {
        id: 'gateway.views.TWIA.endorsement-detail.Open - Not Bound',
        defaultMessage: 'Open - Not Bound',
    },
    errorLoadingDocuments: {
        id: 'gateway.views.TWIA.endorsement-documents.Error loading documents.',
        defaultMessage: 'Error loading documents.',
    },
    status: {
        id: 'gateway.views.TWIA.endorsement-documents.Status',
        defaultMessage: 'Status',
    },
    underwritingIssues: {
        id: 'gateway.views.TWIA.endorsement-documents.Underwriting Issues',
        defaultMessage: 'Underwriting Issues',
    },
    errorLoadingNotes: {
        id: 'gateway.views.TWIA.endorsement-notes.Error loading notes.',
        defaultMessage: 'Error loading notes.',
    },
    sureWithdrawPolicyChange: {
        id: 'gateway.views.TWIA.endorsement.Are you sure you want to withdraw this policy change?',
        defaultMessage: 'Are you sure you want to withdraw this policy change?',
    },
    withDrawPolicyChange: {
        id: 'gateway.views.TWIA.endorsement.Withdraw Policy Change??',
        defaultMessage: 'Withdraw Policy Change?',
    },
    cancel: {
        id: 'gateway.views.TWIA.endorsement.Cancel',
        defaultMessage: 'Cancel',
    },
    failedtoSavePolicychange: {
        id: 'gateway.views.TWIA.endorsement.Failed to Save Policy Change',
        defaultMessage: 'Failed to Save Policy Change',
    },
    saveAndExit: {
        id: 'gateway.views.TWIA.endorsement.Save and Exit',
        defaultMessage: 'Save and Exit',
    },
    quote: {
        id: 'gateway.views.TWIA.endorsement.Quote',
        defaultMessage: 'Quote',
    },
    savingPolicyChange: {
        id: 'gateway.views.TWIA.endorsement.Saving Policy Change',
        defaultMessage: 'Saving Policy Change',
    },
    unableWithdrawPolicyChange: {
        id: 'gateway.views.TWIA.endorsement.Unable to withdraw this policy change',
        defaultMessage: 'Unable to withdraw this policy change',
    },
    withdraw: {
        id: 'gateway.views.TWIA.endorsement.Withdraw',
        defaultMessage: 'Withdraw',
    },
    withdrawingPolicyChange: {
        id: 'gateway.views.TWIA.endorsement.Withdrawing Policy Change',
        defaultMessage: 'Withdrawing Policy Change',
    },
    failedToWithdrawPolicyChange: {
        id: 'gateway.views.TWIA.endorsement-detail.Failed to withdraw policy change',
        defaultMessage: 'Failed to withdraw policy change',
    },
    error: {
        id: 'gateway.directives.TWIA.JobSummary.Error',
        defaultMessage: 'Error',
    },
    details: {
        id: 'gateway.directives.TWIA.JobSummary.Error.Details',
        defaultMessage: 'Error loading quote information.',
    },
    errorDescription: {
        id: 'gateway.views.TWIA.endorsement-detail.error.create.submission.insufficient-permission',
        defaultMessage: 'This agency or user does not have permission to initiate or process this transaction.'
    }
});
